<template>
  <div id="search-box-wrapper">
    <form class="navbar-form navbar-right" role="search" id="search">
      <md-button @click="showSearch = !showSearch" class="md-just-icon md-round md-simple">
        <i class="fas fa-search" id="outerSearchIcon"></i>
      </md-button>
      <transition name="search">
        <div class="form-group" v-show="showSearch">
          <input
            type="text"
            class="form-control"
            id="outerSearchBox"
            placeholder="What are you looking for?"
            autocomplete="off"
          />
        </div>
      </transition>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showSearch: false
    };
  }
};
</script>
